import script from "./PromoBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoBar.vue?vue&type=script&setup=true&lang=js"

import "./PromoBar.vue?vue&type=style&index=0&id=44508f68&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44508f68"]])

export default __exports__